import React from 'react'
import AnimatePage from '../components/AnimatePage'
import { useQuery } from '@tanstack/react-query'
import { apiClient } from '../helpers/Axios'
import LoadingComponent from '../components/LoadingComponent'
import LogError from '../components/LogError'
import SectionHead from '../components/SectionHead'
import { MdOutlineReportGmailerrorred } from 'react-icons/md'
import Wrapper from '../helpers/Wrapper'
import Product from '../components/Product/Product'
import { Helmet } from 'react-helmet'
import ReactPaginate from 'react-paginate'
import { useLocation, useSearchParams } from 'react-router-dom'

function Bundles() {

    const [searchParams, setSearchParams] = useSearchParams()
    const location = useLocation();

    const { data, isPending, status, error } = useQuery({
        queryKey: ["bundle-packages", location.search],
        queryFn: async () => {
            const res = await apiClient.get(`product/bundles${location.search}`)
            return res.data
        }
    })


    // Paginate React

    const pageNumberChange = ({ selected }) => {
        searchParams.set("page", selected + 1)
        setSearchParams(searchParams)
    }



    if (isPending) {
        return (
            <LoadingComponent />
        )
    }

    if (status === 'error') {
        return (
            <LogError error={error} />
        )
    }

    return (
        <div className='w-full relative'>
            <Helmet>
                <title>Bundle Packages</title>
            </Helmet>
            <Wrapper>
                <AnimatePage>
                    <div className="w-full mt-16">
                        <SectionHead
                            title="Bundle Packages"
                            description={"Save more with our exclusive bundle packages – curated product sets at unbeatable prices!"}
                        />

                        <div className="mt-8">
                            {data && data?.products?.length > 0 ? (
                                <div className="grid grid-cols-2 mt-8 gap-3 sm:gap-9 lg:grid-cols-4 xl:grid-cols-4">
                                    {data?.products?.map((product, i) => (
                                        <Product key={i} data={product} />
                                    ))}
                                </div>
                            ) :
                                <div>
                                    <div className="bg-[#faf0de] p-5 max-w-64 text-yellow-700 border border-yellow-500 rounded-lg">
                                        <MdOutlineReportGmailerrorred />
                                        <p className="text-[clamp(1rem,2vw+0.9rem,1.1rem]">
                                            No bundle products found
                                        </p>
                                    </div>
                                </div>
                            }
                        </div>

                        <div className="mt-8">
                            {data?.totalPages > 1 && (
                                <div className="mt-8 flex w-full justify-center">
                                    <ReactPaginate
                                        previousLabel={false}
                                        nextLabel={false}
                                        breakLabel="..."
                                        pageCount={Number(data?.totalPages)}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={1}
                                        onPageChange={pageNumberChange}
                                        containerClassName={'flex items-center gap-3 mx-5 relative justify-center'}
                                        pageClassName={`border size-12 flex items-center justify-center rounded-full 
                                                hover:border-black transition`}
                                        activeClassName={'border-black'}
                                        previousLinkClassName={'previous-link'}
                                        nextLinkClassName={'next-link'}
                                    />

                                </div>
                            )}
                        </div>
                    </div>
                </AnimatePage>
            </Wrapper>
        </div>
    )
}

export default Bundles